import axios from "axios";

const API_BASE = "http://localhost:5000";

const IS_PROD = process.env.NODE_ENV === 'production';

// ----------------------- 🟢 Config --------------------------
const LOCAL_NODE = "http://localhost:5000";
// const LOCAL_PHP = "http://localhost:8080";
const LOCAL_PHP = "https://staging.via-app.ca/via_api/";
const PROD_BACKEND = "https://staging.via-app.ca/via_api";

// 🟢 APIs
// const API_BASE = IS_PROD ? `${PROD_BACKEND}/api` : LOCAL_NODE;
const API_BASE2 = IS_PROD ? `${PROD_BACKEND}/api` : `${LOCAL_PHP}/api`;
const API_BASE3 = IS_PROD ? `${PROD_BACKEND}/pages` : `${LOCAL_PHP}/pages`;

// 🟢 Assets
const ASSET_BASE = IS_PROD ? PROD_BACKEND : LOCAL_PHP;
//----------------------- 🟢 Home API--------------------------
export const getHomeData = async (lang = 'en') => {
  const page = await getPageBySlug('home', lang);
  const seo = {
    title: page?.seo?.titleEn || page?.seo?.title || '',
    description: page?.seo?.descriptionEn || page?.seo?.description || '',
    keywords: page?.seo?.keywordsEn || page?.seo?.keywords || ''
  };
  const h = page?.hero || {};
  const hero = {
    background: h.background || '',
    logo: h.logo || '',
    color1: h.color1 || '#0071BD',
    color2: h.color2 || '#93D52D',
    title: h.titleEn || h.title || '',
    description: h.descriptionEn || h.description || '',
    btn: h.btnEn || h.btnText || ''
  };
  const aboutSec = (Array.isArray(page.sections) ? page.sections.find(s => (String(s.type || s.component).toLowerCase() === 'about' || String(s.type || '').toLowerCase() === 'about_section')) : null) || {};
  const about = {
    title: aboutSec.title_en || aboutSec.lang?.title || '',
    subtitle: aboutSec.subtitle_en || aboutSec.lang?.subtitle || '',
    description: aboutSec.description_en || aboutSec.lang?.description || '',
    image: aboutSec.image || ''
  };
  const tRaw = page?.testimonials || {};
  const testimonials = {
    title: tRaw.title || tRaw.title_en || '',
    subtitle: tRaw.subtitle || tRaw.subtitle_en || '',
    cards: (Array.isArray(tRaw.cards) ? tRaw.cards : []).map((t, i) => ({
      id: t.id ?? i,
      avatar: t.avatar || '',
      companyname: t.company || '',
      name: t.name_en || t.lang?.title || '',
      role: t.role_en || t.lang?.subtitle || '',
      comment: t.comment_en || t.lang?.comment || ''
    }))
  };
  const sRaw = page?.stats || {};
  const stats = {
    title: sRaw.title_en || sRaw.lang?.title || '',
    items: (Array.isArray(sRaw.items) ? sRaw.items : []).map((it, i) => ({
      id: it.id ?? i,
      number: String(it.number || '0'),
      label: it.label_en || it.lang?.label || '',
      color: it.color || '#0071BD'
    }))
  };
  const contactSec = (Array.isArray(page.sections) ? page.sections.find(s => (String(s.type || s.component).toLowerCase() === 'contact' || String(s.type || '').toLowerCase() === 'contact_section')) : null) || {};
  const contact = {
    title: contactSec.title_en || contactSec.lang?.title || 'اتصل بنا',
    subtitle: contactSec.subtitle_en || contactSec.lang?.subtitle || '',
    btnText: contactSec.btn_text_en || contactSec.lang?.btn_text || 'تواصل معنا',
    background: contactSec.background_image || contactSec.image || '',
    color1: '#0071BD',
    color2: '#93D52D'
  };
  return { seo, hero, about, testimonials, stats, contact };
};
export const updateHomeData = async (data) => {
  const payload = {};
  if (data.seo) {
    payload.seo = {
      title_en: data.seo.titleEn || data.seo.title || '',
      title_ar: data.seo.titleAr || '',
      seo_title_en: data.seo.seoTitleEn || data.seo.titleEn || data.seo.title || '',
      seo_title_ar: data.seo.seoTitleAr || data.seo.titleAr || '',
      seo_description_en: data.seo.descriptionEn || data.seo.description || '',
      seo_description_ar: data.seo.descriptionAr || '',
      seo_keyword_en: data.seo.keywordsEn || data.seo.keywords || '',
      seo_keyword_ar: data.seo.keywordsAr || ''
    };
  }
  if (data.hero) {
    const h = data.hero;
    payload.hero = {
      title_en: h.titleEn || h.title || '',
      title_ar: h.titleAr || '',
      description_en: h.descriptionEn || h.description || '',
      description_ar: h.descriptionAr || '',
      btn_text_en: h.btnEn || h.btn || '',
      btn_text_ar: h.btnAr || ''
    };
    if (h.logo && h.logo instanceof File) payload.hero.logo = h.logo;
    if (h.background && h.background instanceof File) payload.hero.background = h.background;
  }
  const sections = {};
  if (data.about) {
    const a = data.about;
    sections[0] = { id: a.id || a.section_id || a.sectionId, type: 'about', title_en: a.title || a.titleEn || '', title_ar: a.titleAr || '', subtitle_en: a.subtitle || a.subtitleEn || '', subtitle_ar: a.subtitleAr || '', description_en: a.description || a.descriptionEn || '', description_ar: a.descriptionAr || '' };
    if (a.image && a.image instanceof File) sections[0].image = a.image;
  }
  if (data.contact) {
    const c = data.contact;
    sections[1] = {
      id: c.id || c.section_id || c.sectionId,
      type: 'contact',
      title_en: c.title || c.titleEn || '',
      title_ar: c.titleAr || '',
      subtitle_en: c.subtitle || c.subtitleEn || '',
      subtitle_ar: c.subtitleAr || '',
      btn_text_en: c.btnText || c.btnTextEn || '',
      btn_text_ar: c.btnTextAr || '',
      stepsbold_en: c.color1 || '',
      stepsbold_ar: c.color2 || ''
    };
    if (c.background && c.background instanceof File) sections[1].background_image = c.background;
  }
  if (Object.keys(sections).length) payload.sections = sections;
  if (data.stats) {
    payload.stats = { title_en: data.stats.title || data.stats.titleEn || '', title_ar: data.stats.titleAr || '', items: (Array.isArray(data.stats.items) ? data.stats.items : []).map((it, i) => ({ number: String(it.number || '0'), color: it.color || '#0071BD', label_en: it.label || '', label_ar: it.labelAr || '' })) };
  }
  if (data.testimonials) {
    const t = data.testimonials;
    payload.testimonials = {
      title_en: t.title || t.titleEn || '',
      title_ar: t.titleAr || '',
      subtitle_en: t.subtitle || t.subtitleEn || '',
      subtitle_ar: t.subtitleAr || '',
      cards: (Array.isArray(t.cards) ? t.cards : []).map((c, i) => ({
        id: c.id,
        display_order: c.display_order || (i + 1),
        name_en: c.name || c.nameEn || '',
        name_ar: c.nameAr || '',
        role_en: c.role || c.roleEn || '',
        role_ar: c.roleAr || '',
        comment_en: c.comment || c.commentEn || '',
        comment_ar: c.commentAr || '',
        company: c.companyname || '',
        avatar: c.avatar instanceof File ? c.avatar : undefined
      }))
    };
  }
  return updatePage('home', payload);
};
//----------------------- 🟢 Services Main API--------------------------
export const getServicesMainData = async () => {
  const res = await axios.get(`${API_BASE}/servicesmain`);
  return res.data;
};
export const updateServicesMainData = async (data) => {
  const res = await axios.put(`${API_BASE}/servicesmain`, data);
  return res.data;
};
// -------------------------🟢 Services---------------------
export const getServicesData = async () => {
  const res = await axios.get(`${API_BASE}/services`);
  return res.data;
};
export const getServiceBySlug = (slug) =>
  axios.get(`${API_BASE}/services?slug=${encodeURIComponent(slug)}`).then(r => r.data[0]);

export const createService = (service) =>
  axios.post(`${API_BASE}/services`, service).then(r => r.data);

export const updateService = (id, data) =>
  axios.patch(`${API_BASE}/services/${id}`, data).then(r => r.data);

export const deleteService = (id) =>
  axios.delete(`${API_BASE}/services/${id}`);
//----------------------- 🟢 Reseller Locations API--------------------------
export const getResellerLocationsData = async () => {
  const res = await axios.get(`${API_BASE}/locations`);
  return res.data;
};
export const updateResellerLocationsData = async (data) => {
  const res = await axios.put(`${API_BASE}/locations`, data);
  return res.data;
};
//----------------------- 🟢 Contact us API--------------------------
export const getContactData = async () => {
  try {
    const [page, footerRes] = await Promise.all([
      getPageBySlug('contact-us', 'en'),
      axios.get(`${API_BASE2}/footer`).then(r => r.data)
    ]);
    const footer = footerRes.footer || {};
    const seo = {
      title: page?.seo?.titleEn || '',
      description: page?.seo?.descriptionEn || '',
      keywords: page?.seo?.keywordsEn || ''
    };
    const contact = {
      email: footer?.contact?.email || '',
      phone: footer?.contact?.phone || '',
      address: footer?.contact?.addressEn || footer?.contact?.addressAr || '',
      mapSrc: footer?.contact?.addressLink || ''
    };
    const socialLinks = (footer?.contact?.social || []).map((s, idx) => ({
      id: s.id ?? idx,
      icon: s.icon || 'FaFacebookF',
      url: s.url || '#',
      hidden: String(s.is_hidden ?? '0') === '1' || !!s.hidden,
      color: '#0077b6'
    }));
    return { seo, contact, social: { links: socialLinks } };
  } catch (e) {
    const res = await axios.get(`${API_BASE2}/footer`).then(r => r.data);
    const f = res.footer || {};
    return {
      seo: { title: '', description: '', keywords: '' },
      contact: {
        email: f?.contact?.email || '',
        phone: f?.contact?.phone || '',
        address: f?.contact?.addressEn || f?.contact?.addressAr || '',
        mapSrc: f?.contact?.addressLink || ''
      },
      social: { links: (f?.contact?.social || []).map((s, idx) => ({ id: s.id ?? idx, icon: s.icon || 'FaFacebookF', url: s.url || '#', hidden: String(s.is_hidden ?? '0') === '1' || !!s.hidden, color: '#0077b6' })) }
    };
  }
};
export const updateContactData = async (data) => {
  const updates = [];
  if (data?.seo) {
    const s = data.seo;
    const seoPayload = {
      title_en: s.title || '',
      seo_title_en: s.title || '',
      seo_description_en: s.description || '',
      seo_keyword_en: s.keywords || ''
    };
    updates.push(updatePage('contact-us', { seo: seoPayload }));
  }
  const fd = new FormData();
  const c = data?.contact || {};
  fd.append('addressLink', c.mapSrc || c.addressLink || '');
  fd.append('phone', c.phone || '');
  fd.append('phoneLink', c.phone ? `tel:${c.phone}` : '');
  fd.append('email', c.email || '');
  fd.append('emailLink', c.email ? `mailto:${c.email}` : '');
  fd.append('descriptionEn', '');
  fd.append('descriptionAr', '');
  fd.append('addressEn', c.address || '');
  fd.append('addressAr', c.address || '');
  const links = data?.social?.links || [];
  links.forEach((s, i) => {
    fd.append(`social[${i}][icon]`, s.icon || '');
    fd.append(`social[${i}][url]`, s.url || '');
    fd.append(`social[${i}][hidden]`, s.hidden ? 1 : 0);
  });
  updates.push(axios.post(`${API_BASE2}/footer/1`, fd));
  await Promise.all(updates);
  return { success: true };
};

//  Cards operations
export const addContactCard = async (card) => {
  const res = await axios.post(`${API_BASE}/cards-contactus`, card);
  return res.data;
};
export const deleteContactCard = async (id) => {
  await axios.delete(`${API_BASE}/cards-contactus/${id}`);
};
//----------------------- 🟢 Footer API--------------------------
export const getFooterData = async () => {
  const res = await axios.get(`${API_BASE2}/footer`).then((r) => r.data);
  const raw = res.footer || res || {};
  const normalize = (s) => String(s || '').replace(/[`'\"]/g, '').trim();
  const socialArr = Array.isArray(raw?.contact?.social) ? raw.contact.social : [];
  const socialLinks = socialArr.map((s, idx) => ({
    id: s.id ?? idx,
    icon: s.icon || 'FaFacebookF',
    url: normalize(s.url || ''),
    hidden: String(s.is_hidden ?? '0') === '1' || !!s.hidden,
    color: '#00b4d8',
  })).filter((s) => !!s.url);
  const footer = {
    id: String(raw.id ?? '1'),
    logo: raw.logo || '',
    logo_url: normalize(raw.logo_url || ''),
    descriptionEn: raw.descriptionEn || '',
    descriptionAr: raw.descriptionAr || '',
    contact: {
      addressEn: raw?.contact?.addressEn || raw?.contact?.address || '',
      addressAr: raw?.contact?.addressAr || raw?.contact?.addressAr || '',
      addressLink: normalize(raw?.contact?.addressLink || ''),
      phone: raw?.contact?.phone || '',
      phoneLink: normalize(raw?.contact?.phoneLink || (raw?.contact?.phone ? `tel:${raw.contact.phone}` : '')),
      email: raw?.contact?.email || '',
      emailLink: normalize(raw?.contact?.emailLink || (raw?.contact?.email ? `mailto:${raw.contact.email}` : '')),
      social: socialLinks,
    },
  };
  return { footer, phone: footer.contact.phone || '', social: { links: socialLinks } };
};
export const updateFooterData = async (data) => {
  const fd = new FormData();
  const c = data?.contact || {};
  fd.append('addressLink', c.addressLink || c.mapSrc || '');
  fd.append('phone', c.phone || '');
  fd.append('phoneLink', c.phoneLink || (c.phone ? `tel:${c.phone}` : ''));
  fd.append('email', c.email || '');
  fd.append('emailLink', c.emailLink || (c.email ? `mailto:${c.email}` : ''));
  fd.append('descriptionEn', data?.descriptionEn || '');
  fd.append('descriptionAr', data?.descriptionAr || '');
  fd.append('addressEn', c.addressEn || c.address || '');
  fd.append('addressAr', c.addressAr || c.address || '');
  const links = (Array.isArray(c.social) ? c.social : (data?.social?.links || [])).map((s) => ({
    icon: s.icon || 'FaFacebookF',
    url: String(s.url || ''),
    hidden: !!s.hidden,
  }));
  links.forEach((s, i) => {
    fd.append(`social[${i}][icon]`, s.icon || '');
    fd.append(`social[${i}][url]`, s.url || '');
    fd.append(`social[${i}][hidden]`, s.hidden ? 1 : 0);
  });
  if (data.logo instanceof File) {
    fd.append('logo', data.logo);
  }
  const res = await axios.post(`${API_BASE2}/footer/${data?.id || 1}`, fd);
  return res.data;
};


// -------------------------🟢 Footer---------------------
// export const getFooterData = async () => {
//   const res = await axios.get(`${API_BASE2}/footer`);
//   return res.data;
// };

// export const updateFooterData = async (data) => {
//   const formData = new FormData();  // لو كان لديك ملف في data.logo (من نوع File)
//   if (data.logo instanceof File) {
//     formData.append("logo", data.logo);
//   }  // أضف الوصفات
//   formData.append("descriptionEn", data.descriptionEn || "");
//   formData.append("descriptionAr", data.descriptionAr || "");  // أضف حقول الاتصال إذا كانت موجودة
//   if (data.contact) {
//     formData.append("addressEn", data.contact.addressEn || "");
//     formData.append("addressAr", data.contact.addressAr || "");
//     formData.append("addressLink", data.contact.addressLink || "");
//     formData.append("phone", data.contact.phone || "");
//     formData.append("phoneLink", data.contact.phoneLink || "");
//     formData.append("email", data.contact.email || "");
//     formData.append("emailLink", data.contact.emailLink || "");// أضف الروابط الاجتماعية كمصفوفة مفهرسة
//     if (Array.isArray(data.contact.social)) {
//       data.contact.social.forEach((item, index) => {
//         formData.append(`social[${index}][icon]`, item.icon || "");
//         formData.append(`social[${index}][url]`, item.url || "");
//         formData.append(`social[${index}][hidden]`, item.hidden ? "1" : "0");
//       });
//     }
//   } const res = await axios.post(`${API_BASE2}/footer/${data.id}`, formData, {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   }); return res.data;
// };

// -------------------------🟢 Header---------------------
let __headerPromise;
export const getHeaderData = async () => {
  if (__headerPromise) return __headerPromise;
  __headerPromise = axios.get(`${API_BASE2}/header`).then(r => r.data);
  return __headerPromise;
};


export const updateHeaderData = async (data) => {
  const formData = new FormData();

  if (data.logo instanceof File) {
    formData.append("logo", data.logo);
  }
  if (data.color1) formData.append("color1", data.color1);
  if (data.color2) formData.append("color2", data.color2);

  // أضف أي بيانات إضافية (مثل id إن احتجته)
  if (data.id) formData.append("id", data.id);

  const res = await axios.post(`${API_BASE2}/header/${data.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data;
};


//--------------------------
// export const getContactData = async () => {
//   try {
//     const en = await getPageBySlug('contact-us', 'en');
//     const ar = await getPageBySlug('contact-us', 'ar');



//     const seo = {
//       titleEn: en.seo?.titleEn || '',
//       descriptionEn: en.seo?.descriptionEn || '',
//       keywordsEn: en.seo?.keywordsEn || '',
//       titleAr: ar.seo?.titleAr || '',
//       descriptionAr: ar.seo?.descriptionAr || '',
//       keywordsAr: ar.seo?.keywordsAr || ''
//     };

//     const enCards = Array.isArray(en.cards) ? en.cards : [];
//     const arCards = Array.isArray(ar.cards) ? ar.cards : [];
//     const byId = new Map();
//     enCards.forEach((c, idx) => {
//       byId.set(c.id ?? idx, {
//         id: c.id ?? idx,
//         icon: c.icon,
//         image: c.image,
//         link: c.link || '',
//         titleEn: c.lang?.title || c.title_en || '',
//         titleAr: ''
//       });
//     });
//     arCards.forEach((c, idx) => {
//       const id = c.id ?? idx;
//       const prev = byId.get(id) || {
//         id,
//         icon: c.icon,
//         image: c.image,
//         link: c.link || '',
//         titleEn: '',
//         titleAr: ''
//       };
//       prev.titleAr = c.lang?.title || c.title_ar || '';
//       byId.set(id, prev);
//     });

//     return { seo, cards: Array.from(byId.values()) };
//   } catch (e) {
//     const res = await axios.get(`${API_BASE3}/contact-us`);
//     return res.data;
//   }
// };
// export const updateContactData = async (data) => {
//   const payload = {
//     seo: {
//       titleEn: data?.seo?.titleEn || '',
//       titleAr: data?.seo?.titleAr || '',
//       descriptionEn: data?.seo?.descriptionEn || '',
//       descriptionAr: data?.seo?.descriptionAr || '',
//       keywordsEn: data?.seo?.keywordsEn || '',
//       keywordsAr: data?.seo?.keywordsAr || ''
//     },

//     cards: (Array.isArray(data?.cards) ? data.cards : []).map((c, idx) => ({
//       id: c.id,
//       titleEn: c.titleEn || '',
//       titleAr: c.titleAr || '',
//       icon: c.icon,
//       link: c.link || '',
//       type: c.type || 'default',
//       card_order: c.card_order || (idx + 1)
//     }))
//   };
//   return updatePage('contact-us', payload);
// };

// // 🟢 Cards operations
// export const addContactCard = async (card) => {
//   const res = await axios.post(`${API_BASE}/cards-contactus`, card);
//   return res.data;
// };
// export const deleteContactCard = async (id) => {
//   await axios.delete(`${API_BASE}/cards-contactus/${id}`);
// };





let __pageBySlugCache = {};
export const getPageBySlug = async (slug, language = "en") => {
  const langId = language === "ar" ? 2 : 1;
  const key = `${slug}|${langId}`;
  if (__pageBySlugCache[key]) return __pageBySlugCache[key];
  const p = axios.get(`${API_BASE3}/${slug}?lang=${langId}`).then((res) => {
    const data = res.data || {};
    const ABS = (p) => (p ? (String(p).startsWith('http') ? p : `${ASSET_BASE}${p}`) : "");
    const heroSrc = data.hero || {};
    const heroLang = heroSrc.lang || {};
    const hero = {
      background: ABS(heroSrc.background || ""),
      logo: ABS(heroSrc.logo || ""),
      color1: heroSrc.color1 || "",
      color2: heroSrc.color2 || "",
      titleEn: language === "en" ? heroLang.title || "" : "",
      titleAr: language === "ar" ? heroLang.title || "" : "",
      descriptionEn: language === "en" ? heroLang.description || "" : "",
      descriptionAr: language === "ar" ? heroLang.description || "" : "",
      btnEn: language === "en" ? heroLang.btn_text || "" : "",
      btnAr: language === "ar" ? heroLang.btn_text || "" : ""
    };
    const seoLang = data.seo || {};
    const seo = {
      titleEn: language === "en" ? (seoLang.seo_title || seoLang.title || "") : "",
      titleAr: language === "ar" ? (seoLang.seo_title || seoLang.title || "") : "",
      descriptionEn: language === "en" ? (seoLang.seo_description || seoLang.description || "") : "",
      descriptionAr: language === "ar" ? (seoLang.seo_description || seoLang.description || "") : "",
      keywordsEn: language === "en" ? (seoLang.seo_keyword || seoLang.keywords || "") : "",
      keywordsAr: language === "ar" ? (seoLang.seo_keyword || seoLang.keywords || "") : ""
    };
    const testimonialsRaw = data.testimonials || {};
    const testimonialsSection = (Array.isArray(data.sections) ? data.sections : []).find((s) => {
      const type = (s.type || s.component || '').toLowerCase();
      return type === 'testimonials' || type === 'testimonials_section';
    }) || {};
    const testimonialsCardsSrc = Array.isArray(testimonialsRaw)
      ? testimonialsRaw
      : (Array.isArray(testimonialsSection.cards) ? testimonialsSection.cards : (testimonialsRaw.cards || []));
    const testimonials = {
      title: language === 'en'
        ? (testimonialsSection.title_en || testimonialsSection.lang?.title || testimonialsRaw.title || '')
        : (testimonialsSection.title_ar || testimonialsSection.lang?.title || testimonialsRaw.titleAr || ''),
      titleAr: language === 'ar'
        ? (testimonialsSection.title_ar || testimonialsSection.lang?.title || testimonialsRaw.titleAr || '')
        : (testimonialsSection.title_en || testimonialsSection.lang?.title || testimonialsRaw.title || ''),
      subtitle: language === 'en'
        ? (testimonialsSection.subtitle_en || testimonialsSection.lang?.subtitle || testimonialsRaw.subtitle || '')
        : (testimonialsSection.subtitle_ar || testimonialsSection.lang?.subtitle || testimonialsRaw.subtitleAr || ''),
      subtitleAr: language === 'ar'
        ? (testimonialsSection.subtitle_ar || testimonialsSection.lang?.subtitle || testimonialsRaw.subtitleAr || '')
        : (testimonialsSection.subtitle_en || testimonialsSection.lang?.subtitle || testimonialsRaw.subtitle || ''),
      cards: testimonialsCardsSrc.map((t) => ({
        id: t.id,
        avatar: ABS(t.avatar || t.image || ''),
        name: language === 'en' ? (t.lang?.title || t.title_en || t.name || '') : undefined,
        nameAr: language === 'ar' ? (t.lang?.title || t.title_ar || t.nameAr || '') : undefined,
        role: language === 'en' ? (t.lang?.subtitle || t.role || '') : undefined,
        roleAr: language === 'ar' ? (t.lang?.subtitle || t.roleAr || '') : undefined,
        comment: language === 'en' ? (t.lang?.comment || t.description_en || t.comment || '') : undefined,
        commentAr: language === 'ar' ? (t.lang?.comment || t.description_ar || t.commentAr || '') : undefined,
        companyname: t.company || t.companyname || ''
      }))
    };
    const firstStat = Array.isArray(data.stats) && data.stats.length > 0 ? data.stats[0] : {};
    const statLang = firstStat.lang || {};
    const stats = {
      title: language === "en" ? statLang.title || "" : "",
      titleAr: language === "ar" ? statLang.title || "" : "",
      items: (firstStat.items || []).map((it) => ({
        id: it.id,
        number: it.number,
        color: it.color,
        label: language === "en" ? (it.lang?.label || "") : undefined,
        labelAr: language === "ar" ? (it.lang?.label || "") : undefined
      }))
    };
    const pageObj = data.page || {};
    const page = {
      slug: pageObj.slug || '',
      image: ABS(pageObj.image || ''),
      bottom_image: ABS(pageObj.bottom_image || '')
    };
    const sections = (Array.isArray(data.sections) ? data.sections : []).map((s) => ({
      ...s,
      image: ABS(s.image || ''),
      background_image: ABS(s.background_image || ''),
      lang: s.lang || {}
    }));
    const cards = (Array.isArray(data.cards) ? data.cards : []).map((c) => {
      const rawIcon = c.icon || '';
      const isIconPath = typeof rawIcon === 'string' && (rawIcon.startsWith('http') || rawIcon.includes('/') || rawIcon.includes('.'));
      const iconVal = isIconPath ? ABS(rawIcon) : rawIcon;
      return {
        id: c.id,
        sec_id: c.sec_id,
        card_order: c.card_order,
        type: c.type,
        image: ABS(c.image || ''),
        icon: iconVal,
        link: c.link || '',
        color: c.color || '',
        color1: c.color1 || '',
        color2: c.color2 || '',
        use_color: c.use_color ?? 0,
        lang: c.lang || {}
      };
    });
    const products = (Array.isArray(data.products) ? data.products : []).map((p) => ({
      id: p.id,
      link: p.link || '',
      logo: ABS(p.logo || ''),
      phone: p.phone || '',
      email: p.email || '',
      map: p.map || '',
      color: p.color || '',
      address: p.address || '',
      display_order: p.display_order || 0,
      is_active: p.is_active ?? 1,
      lang: p.lang || {}
    }));
    const social = data.social || { links: [] };
    const layoutCsv = String(pageObj.layout_order || '').trim();
    const rawLayout = layoutCsv ? layoutCsv.split(',').map(s => String(s).trim().toLowerCase()) : [];
    const isToken = (s) => ['hero', 'sections', 'stats', 'testimonials'].includes(s) || /^section(-)?\d+$/.test(s) || /^sec:\d+$/.test(s);
    const layout = rawLayout.length ? rawLayout.filter(isToken) : ['hero', 'sections', 'stats', 'testimonials'];
    return { hero, seo, testimonials, stats, sections, cards, products, page, social, layout };
  }).finally(() => { delete __pageBySlugCache[key]; });
  __pageBySlugCache[key] = p;
  return p;
};

export const createPage = async (payload) => {
  const res = await axios.post(`${API_BASE3}/create`, payload);
  return res.data;
};

export const setPageActive = async (slug, isActive) => {
  const body = { is_active: isActive ? 1 : 0 };
  const res = await axios.post(`${API_BASE3}/${slug}/status`, body);
  try {
    delete __allPagesCache['1'];
    delete __allPagesCache['2'];
  } catch (e) { }
  return res.data;
};


export const updatePage = async (slug, payload) => {
  const formData = new FormData();
  formData.append('page[slug]', slug);

  // Helper function to append nested fields
  const appendNested = (baseKey, obj) => {
    if (typeof obj !== 'object' || obj === null) return;

    Object.keys(obj).forEach(key => {
      const value = obj[key];
      if (Array.isArray(value)) {
        // Handle arrays like items[0].label → stats[items][0][label_en]
        value.forEach((item, index) => {
          appendNested(`${baseKey}[${key}][${index}]`, item);
        });
      } else if (typeof value === 'object' && !(value instanceof File)) {
        // Recurse for nested objects like cards
        appendNested(`${baseKey}[${key.toLowerCase()}]`, value);
      } else {
        // Simple fields
        const snake = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        formData.append(`${baseKey}[${snake}]`, value ?? '');
      }
    });
  };

  // 1. SEO & Page
  if (payload.seo) {
    appendNested('seo', payload.seo);
    if (payload.page) { // لو في page basics
      appendNested('page', payload.page);
    } else {
      formData.append('page[slug]', slug); // Keep slug
    }
  }

  // Page basics (allow updating even without seo)
  if (payload.page && !payload.seo) {
    appendNested('page', payload.page);
  }
  // Page files
  if (payload.page) {
    if (payload.page.image && payload.page.image instanceof File) {
      formData.append('page_image', payload.page.image);
    }
    if (payload.page.bottom_image && payload.page.bottom_image instanceof File) {
      formData.append('page_bottom_image', payload.page.bottom_image);
    }
  }
  // Page language fields
  if (payload.page_lang) {
    appendNested('page_lang', payload.page_lang);
  }

  // 2. Hero
  if (payload.hero) {
    appendNested('hero', payload.hero);
    const h = payload.hero || {};
    formData.append('hero[title_en]', h.titleEn ?? h.title_en ?? '');
    formData.append('hero[title_ar]', h.titleAr ?? h.title_ar ?? '');
    formData.append('hero[description_en]', h.descriptionEn ?? h.description_en ?? '');
    formData.append('hero[description_ar]', h.descriptionAr ?? h.description_ar ?? '');
    formData.append('hero[btn_text_en]', h.btnEn ?? h.btn_text_en ?? '');
    formData.append('hero[btn_text_ar]', h.btnAr ?? h.btn_text_ar ?? '');
    if (payload.hero.background && payload.hero.background instanceof File) {
      formData.append('hero_background', payload.hero.background);
    }
    if (payload.hero.logo && payload.hero.logo instanceof File) {
      formData.append('hero_logo', payload.hero.logo);
    }
  }

  // 3. Sections (prefer payload.sections; fallback to payload.section2)
  const hasSectionsArray = payload.sections && (Array.isArray(payload.sections) || typeof payload.sections === 'object');
  const hasSection2 = !!payload.section2;
  const sectionsData = hasSectionsArray ? payload.sections : (hasSection2 ? { 0: payload.section2 } : null);
  if (sectionsData) {
    Object.keys(sectionsData).forEach(index => {
      const section = sectionsData[index];
      const lang = section.lang || {};
      const displayOrder = section.display_order || (parseInt(index, 10) + 1);
      let component = section.component || section.type;
      if (!component) {
        if (
          section.paragraphcard1_en || section.paragraphcard1_ar ||
          section.steps_en || section.steps_ar ||
          section.stepsbold_en || section.stepsbold_ar
        ) {
          component = 'section2';
        } else {
          component = 'text-only';
        }
      }
      const type = section.type || component;

      // display_order intentionally not sent for sections
      formData.append(`sections[${index}][type]`, type);
      const sectionId = section.id ?? section.section_id ?? section.sectionId;
      if (sectionId) {
        formData.append(`sections[${index}][id]`, sectionId);
      }
      if (section.deleted) {
        formData.append(`sections[${index}][deleted]`, 1);
      }

      const title_en = section.title_en ?? section.titlecard1En ?? section.titlecard1_en ?? lang.title ?? '';
      const title_ar = section.title_ar ?? section.titlecard1Ar ?? section.titlecard1_ar ?? lang.title_ar ?? '';
      const subtitle_en = section.subtitle_en ?? lang.subtitle ?? '';
      const subtitle_ar = section.subtitle_ar ?? lang.subtitle_ar ?? '';
      const description_en = section.description_en ?? section.paragraphcard1En ?? section.paragraphcard1_en ?? lang.description ?? '';
      const description_ar = section.description_ar ?? section.paragraphcard1Ar ?? section.paragraphcard1_ar ?? lang.description_ar ?? '';
      const btn_text_en = section.btn_text_en ?? section.btnEn ?? section.btncard_en ?? lang.btn_text ?? '';
      const btn_text_ar = section.btn_text_ar ?? section.btnAr ?? section.btncard_ar ?? lang.btn_text_ar ?? '';
      formData.append(`sections[${index}][title_en]`, title_en);
      formData.append(`sections[${index}][title_ar]`, title_ar);
      formData.append(`sections[${index}][subtitle_en]`, subtitle_en);
      formData.append(`sections[${index}][subtitle_ar]`, subtitle_ar);
      formData.append(`sections[${index}][description_en]`, description_en);
      formData.append(`sections[${index}][description_ar]`, description_ar);
      formData.append(`sections[${index}][btn_text_en]`, btn_text_en);
      formData.append(`sections[${index}][btn_text_ar]`, btn_text_ar);
      if (section.color1 != null) {
        formData.append(`sections[${index}][color1]`, section.color1 || '');
      }
      if (section.color2 != null) {
        formData.append(`sections[${index}][color2]`, section.color2 || '');
      }
      const p1_en = section.paragraphcard1_en ?? section.paragraphcard1En ?? '';
      const p1_ar = section.paragraphcard1_ar ?? section.paragraphcard1Ar ?? '';
      if (p1_en || p1_ar) {
        formData.append(`sections[${index}][paragraphcard1_en]`, p1_en);
        formData.append(`sections[${index}][paragraphcard1_ar]`, p1_ar);
      }
      const stepsbold_en = section.stepsbold_en ?? section.titlecard2En ?? section.titlecard2_en ?? '';
      const stepsbold_ar = section.stepsbold_ar ?? section.titlecard2Ar ?? section.titlecard2_ar ?? '';
      if (stepsbold_en || stepsbold_ar) {
        formData.append(`sections[${index}][stepsbold_en]`, stepsbold_en);
        formData.append(`sections[${index}][stepsbold_ar]`, stepsbold_ar);
      }
      const steps_en = section.steps_en ?? section.paragraphcard2En ?? section.paragraphcard2_en ?? '';
      const steps_ar = section.steps_ar ?? section.paragraphcard2Ar ?? section.paragraphcard2_ar ?? '';
      if (steps_en || steps_ar) {
        formData.append(`sections[${index}][steps_en]`, steps_en);
        formData.append(`sections[${index}][steps_ar]`, steps_ar);
      }

      if (section.bg_color1) formData.append(`sections[${index}][bg_color1]`, section.bg_color1);
      if (section.bg_color2) formData.append(`sections[${index}][bg_color2]`, section.bg_color2);
      if (section.use_bg_color !== undefined) formData.append(`sections[${index}][use_bg_color]`, section.use_bg_color);

      if (Array.isArray(section.cards)) {
        section.cards.forEach((card, cIdx) => {
          const cTitleEn = card.title_en ?? card.titleEn ?? '';
          const cTitleAr = card.title_ar ?? card.titleAr ?? '';
          const cDescEn = card.description_en ?? card.descriptionEn ?? '';
          const cDescAr = card.description_ar ?? card.descriptionAr ?? '';
          const cLink = card.link ?? card.btnLink ?? '';
          const cClientEn = card.client_en ?? card.clientEn ?? '';
          const cClientAr = card.client_ar ?? card.clientAr ?? '';
          const cSolutionEn = card.solution_en ?? card.solutionEn ?? '';
          const cSolutionAr = card.solution_ar ?? card.solutionAr ?? '';
          const cResultEn = card.result_en ?? card.resultEn ?? '';
          const cResultAr = card.result_ar ?? card.resultAr ?? '';
          const cTagsEnArr = card.tags_en ?? card.tags ?? [];
          const cTagsArArr = card.tags_ar ?? card.tags ?? [];
          const cTagsEn = Array.isArray(cTagsEnArr) ? cTagsEnArr.join(',') : (cTagsEnArr || '');
          const cTagsAr = Array.isArray(cTagsArArr) ? cTagsArArr.join(',') : (cTagsArArr || '');
          const cTechEnArr = card.tech_stack_en ?? card.tech ?? [];
          const cTechArArr = card.tech_stack_ar ?? card.tech ?? [];
          const cTechEn = Array.isArray(cTechEnArr) ? cTechEnArr.join(',') : (cTechEnArr || '');
          const cTechAr = Array.isArray(cTechArArr) ? cTechArArr.join(',') : (cTechArArr || '');

          let cardType = card.type;
          if (!cardType) {
            switch (component) {
              case 'section3': cardType = 'service'; break;
              case 'section4': cardType = 'solution'; break;
              case 'testimonials': cardType = 'testimonial'; break;
              case 'section5': cardType = 'client'; break;
              default: cardType = 'default';
            }
          }

          if (card.id) formData.append(`sections[${index}][cards][${cIdx}][id]`, card.id);
          formData.append(`sections[${index}][cards][${cIdx}][card_order]`, card.card_order ?? (cIdx + 1));
          formData.append(`sections[${index}][cards][${cIdx}][title_en]`, cTitleEn);
          formData.append(`sections[${index}][cards][${cIdx}][title_ar]`, cTitleAr);
          formData.append(`sections[${index}][cards][${cIdx}][description_en]`, cDescEn);
          formData.append(`sections[${index}][cards][${cIdx}][description_ar]`, cDescAr);
          formData.append(`sections[${index}][cards][${cIdx}][link]`, cLink);
          formData.append(`sections[${index}][cards][${cIdx}][type]`, cardType);
          if (card.deleted) formData.append(`sections[${index}][cards][${cIdx}][deleted]`, 1);
          // Optional extended language fields
          if (cClientEn || cClientAr) {
            formData.append(`sections[${index}][cards][${cIdx}][client_en]`, cClientEn);
            formData.append(`sections[${index}][cards][${cIdx}][client_ar]`, cClientAr);
          }
          if (cSolutionEn || cSolutionAr) {
            formData.append(`sections[${index}][cards][${cIdx}][solution_en]`, cSolutionEn);
            formData.append(`sections[${index}][cards][${cIdx}][solution_ar]`, cSolutionAr);
          }
          if (cResultEn || cResultAr) {
            formData.append(`sections[${index}][cards][${cIdx}][result_en]`, cResultEn);
            formData.append(`sections[${index}][cards][${cIdx}][result_ar]`, cResultAr);
          }
          if (cTechEn || cTechAr) {
            formData.append(`sections[${index}][cards][${cIdx}][tech_stack_en]`, cTechEn);
            formData.append(`sections[${index}][cards][${cIdx}][tech_stack_ar]`, cTechAr);
          }
          if (cTagsEn || cTagsAr) {
            formData.append(`sections[${index}][cards][${cIdx}][tags_en]`, cTagsEn);
            formData.append(`sections[${index}][cards][${cIdx}][tags_ar]`, cTagsAr);
          }

          if (card.icon && card.icon instanceof File) formData.append(`sections_${index}_cards_${cIdx}_icon`, card.icon);
          if (card.img && card.img instanceof File) formData.append(`sections_${index}_cards_${cIdx}_image`, card.img);
          if (card.image && card.image instanceof File) formData.append(`sections_${index}_cards_${cIdx}_image`, card.image);
          if (card.background_image && card.background_image instanceof File) formData.append(`sections_${index}_cards_${cIdx}_background_image`, card.background_image);
          // If icon/image are strings, include them in nested data so backend can persist
          if (card.icon && typeof card.icon === 'string') formData.append(`sections[${index}][cards][${cIdx}][icon]`, card.icon);
          const imgStr = (typeof card.img === 'string') ? card.img : (typeof card.image === 'string' ? card.image : '');
          if (imgStr) formData.append(`sections[${index}][cards][${cIdx}][image]`, imgStr);
          if (typeof card.background_image === 'string') formData.append(`sections[${index}][cards][${cIdx}][background_image]`, card.background_image);
          if (card.color) formData.append(`sections[${index}][cards][${cIdx}][color]`, card.color);
          if (card.color1) formData.append(`sections[${index}][cards][${cIdx}][color1]`, card.color1);
          if (card.color2) formData.append(`sections[${index}][cards][${cIdx}][color2]`, card.color2);
          if (card.use_color !== undefined) formData.append(`sections[${index}][cards][${cIdx}][use_color]`, card.use_color);

        });
      }

      if (section.image && section.image instanceof File) formData.append(`sections_${index}_image`, section.image);
      if (section.img && section.img instanceof File) formData.append(`sections_${index}_image`, section.img);
      if (section.background_image && section.background_image instanceof File) formData.append(`sections_${index}_background_image`, section.background_image);
      if (typeof section.image === 'string') formData.append(`sections[${index}][image]`, section.image);
      if (typeof section.img === 'string') formData.append(`sections[${index}][image]`, section.img);
      if (typeof section.background_image === 'string') formData.append(`sections[${index}][background_image]`, section.background_image);
    });
  }

  // 4. Root Cards: always send when provided (affects only page-level cards with sec_id=null)
  if (payload.cards && Array.isArray(payload.cards)) {
    if (payload.cards.length === 0) {
      formData.append('cards_clear', 1);
    }
    payload.cards.forEach((card, index) => {
      formData.append(`cards[${index}][card_order]`, card.card_order || (index + 1));
      formData.append(`cards[${index}][link]`, card.btnLink || card.link || '');
      if (card.textEn || card.descriptionEn) {
        formData.append(`cards[${index}][text_en]`, card.textEn ?? card.descriptionEn ?? '');
      }
      if (card.textAr || card.descriptionAr) {
        formData.append(`cards[${index}][text_ar]`, card.textAr ?? card.descriptionAr ?? '');
      }
      const imgStr = (typeof card.img === 'string') ? card.img : (typeof card.image === 'string' ? card.image : '');
      if (imgStr) formData.append(`cards[${index}][image]`, imgStr);
      const techArr = card.tech ?? [];
      if (Array.isArray(techArr) && techArr.length) formData.append(`cards[${index}][tech_stack_en]`, techArr.join(','));
      const tagsArr = card.tags ?? [];
      if (Array.isArray(tagsArr) && tagsArr.length) formData.append(`cards[${index}][tags_en]`, tagsArr.join(','));
      appendNested(`cards[${index}]`, card);
      if (typeof card.icon === 'string') {
        formData.append(`cards[${index}][icon]`, card.icon || '');
      }
      if (card.icon && card.icon instanceof File) formData.append(`cards_${index}_icon`, card.icon);
      if (card.img && card.img instanceof File) formData.append(`cards_${index}_image`, card.img);
      if (card.image && card.image instanceof File) formData.append(`cards_${index}_image`, card.image);
    });
  }

  // 5. Testimonials
  if (payload.testimonials) {
    const t = payload.testimonials;
    formData.append('testimonials[title_en]', t.title_en ?? t.title ?? '');
    formData.append('testimonials[title_ar]', t.title_ar ?? t.titleAr ?? '');
    formData.append('testimonials[subtitle_en]', t.subtitle_en ?? t.subtitle ?? '');
    formData.append('testimonials[subtitle_ar]', t.subtitle_ar ?? t.subtitleAr ?? '');
    if (t.bg_color1) formData.append('testimonials[bg_color1]', t.bg_color1);
    if (t.bg_color2) formData.append('testimonials[bg_color2]', t.bg_color2);
    if (t.use_bg_color !== undefined) formData.append('testimonials[use_bg_color]', t.use_bg_color);

    if (Array.isArray(t.cards)) {
      t.cards.forEach((card, index) => {
        if (card.id) formData.append(`testimonials[cards][${index}][id]`, card.id);
        formData.append(`testimonials[cards][${index}][display_order]`, card.display_order || (index + 1));
        formData.append(`testimonials[cards][${index}][name_en]`, card.name_en ?? card.name ?? '');
        formData.append(`testimonials[cards][${index}][name_ar]`, card.name_ar ?? card.nameAr ?? '');
        formData.append(`testimonials[cards][${index}][role_en]`, card.role_en ?? card.role ?? '');
        formData.append(`testimonials[cards][${index}][role_ar]`, card.role_ar ?? card.roleAr ?? '');
        formData.append(`testimonials[cards][${index}][comment_en]`, card.comment_en ?? card.comment ?? '');
        formData.append(`testimonials[cards][${index}][comment_ar]`, card.comment_ar ?? card.commentAr ?? '');
        formData.append(`testimonials[cards][${index}][company]`, card.company ?? card.companyname ?? '');
        if (card.avatar && card.avatar instanceof File) formData.append(`testimonials_cards_${index}_avatar`, card.avatar);
      });
    }
  }

  if (payload.products && Array.isArray(payload.products)) {
    payload.products.forEach((prod, index) => {
      if (prod.id) formData.append(`products[${index}][id]`, prod.id);
      formData.append(`products[${index}][display_order]`, prod.display_order || (index + 1));
      formData.append(`products[${index}][link]`, prod.link || '');
      formData.append(`products[${index}][phone]`, prod.phone || '');
      formData.append(`products[${index}][email]`, prod.email || '');
      formData.append(`products[${index}][map]`, prod.map || '');
      formData.append(`products[${index}][color]`, prod.color || '');
      formData.append(`products[${index}][address]`, prod.address || '');
      if (prod.address_en != null) formData.append(`products[${index}][address_en]`, prod.address_en || '');
      if (prod.address_ar != null) formData.append(`products[${index}][address_ar]`, prod.address_ar || '');
      formData.append(`products[${index}][is_active]`, prod.is_active != null ? prod.is_active : 1);
      const nEn = prod.name_en ?? prod.nameEn ?? '';
      const nAr = prod.name_ar ?? prod.nameAr ?? '';
      const tEn = prod.title_en ?? prod.titleEn ?? '';
      const tAr = prod.title_ar ?? prod.titleAr ?? '';
      const dEn = prod.description_en ?? prod.descriptionEn ?? prod.description ?? '';
      const dAr = prod.description_ar ?? prod.descriptionAr ?? '';
      formData.append(`products[${index}][name_en]`, nEn);
      formData.append(`products[${index}][name_ar]`, nAr);
      formData.append(`products[${index}][title_en]`, tEn);
      formData.append(`products[${index}][title_ar]`, tAr);
      formData.append(`products[${index}][description_en]`, dEn);
      formData.append(`products[${index}][description_ar]`, dAr);
      if (prod.logo && prod.logo instanceof File) formData.append(`products_${index}_logo`, prod.logo);
      const logoStr = (typeof prod.logo === 'string') ? prod.logo : '';
      if (logoStr) formData.append(`products[${index}][logo]`, logoStr);
    });
  }

  // Social links for page
  if (payload.social && Array.isArray(payload.social)) {
    payload.social.forEach((item, index) => {
      formData.append(`social[${index}][icon]`, item.icon || '');
      formData.append(`social[${index}][url]`, item.url || '');
      formData.append(`social[${index}][hidden]`, item.hidden ? 1 : 0);
    });
  }

  // 6. Stats
  if (payload.stats) {
    const s = payload.stats;
    formData.append('stats[title_en]', s.title_en ?? s.title ?? '');
    formData.append('stats[title_ar]', s.title_ar ?? s.titleAr ?? '');
        if (s.bg_color1) formData.append('stats[bg_color1]', s.bg_color1);
    if (s.bg_color2) formData.append('stats[bg_color2]', s.bg_color2);
    if (s.use_bg_color !== undefined) formData.append('stats[use_bg_color]', s.use_bg_color);

    if (Array.isArray(s.items)) {
      s.items.forEach((item, index) => {
        formData.append(`stats[items][${index}][display_order]`, item.display_order || (index + 1));
        formData.append(`stats[items][${index}][number]`, item.number || '');
        formData.append(`stats[items][${index}][color]`, item.color || '#0071BD');
        formData.append(`stats[items][${index}][label_en]`, item.label_en ?? item.label ?? '');
        formData.append(`stats[items][${index}][label_ar]`, item.label_ar ?? item.labelAr ?? '');
      });
    }
  }

  // أرسل كـ FormData
  try {
    const debugEntries = [];
    for (const [k, v] of formData.entries()) {
      debugEntries.push([k, v instanceof File ? `FILE:${v.name}` : String(v)]);
    }
    console.debug('updatePage formData', debugEntries);

    const res = await axios.post(`${API_BASE3}/${slug}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return res.data;
  } catch (e) {
    console.error('updatePage error', e);
    throw e;
  }
};

// Delete a dynamic section by id
export const deleteSectionById = async (slug, sectionId) => {
  return axios.delete(`${API_BASE3}/${slug}/sections/${sectionId}`);
};

let __allPagesCache = {};
export const getallpage = async (lang = 1) => {
  const key = String(lang);
  if (__allPagesCache[key]) return __allPagesCache[key];
  const p = axios.get(`${API_BASE3}/all?lang=${lang}`).then(r => r.data);
  __allPagesCache[key] = p;
  return p;
};

// Menus
export const getMenus = async () => axios.get(`${API_BASE2}/menu`);
export const createMenu = async (data) => axios.post(`${API_BASE2}/menu`, data);
export const updateMenu = async (id, data) => axios.put(`${API_BASE2}/menu/${id}`, data);
export const deleteMenu = async (id) => axios.delete(`${API_BASE2}/menu/${id}`);

let __submenusCache = {};
export const getSubmenus = async (lang = 1) => {
  const key = String(lang);
  if (__submenusCache[key]) return __submenusCache[key];
  const p = axios.get(`${API_BASE2}/submenu?lang=${lang}`);
  __submenusCache[key] = p;
  return p;
};
export const createSubmenu = async (data) => axios.post(`${API_BASE2}/submenu`, data);
export const updateSubmenu = async (id, data) => axios.put(`${API_BASE2}/submenu/${id}`, data);
export const deleteSubmenu = async (id) => axios.delete(`${API_BASE2}/submenu/${id}`);
